/**
 * NavigationLabelsOverview
 *
 * Important: The OrderedSearchFacetApiController adds a specific caching header to prevent the
 * whole navigation structure being loaded for each single request. Thus we add the shopProfileCode
 * (authorized = customer logged in / default = customer not logged in) and the current software
 * revison to the request. This leads to separate caches e.g. for the navigation in guest and
 * logged in view.
 */
class NavigationLabelsOverview
{
    /**
	 * NavigationLabelsOverview constructor
	 */
    constructor()
    {
        /**
		 * @type {string}
		 */
        this.labelsOverviewSelector = '.js-labels-overview';
    }

    /**
	 * Initialize the labels overview
	 */
    init()
    {
        this.fetchLabelList().done(labelList =>
        {
            this.processLabelsOverview(labelList);
        });
    }


    /**
	 * Returns a promise of the request to fetch the labels
	 * @return {jqXHR} promise of the ordered search facet request
	 */
    fetchLabelList()
    {
        // beware, dirty stuff. We need the revision id here, but theres no
        // possibility to get in javascript atm so we're fetching it from
        // another asset.
        let query = '?';
        let assetElement = document.querySelector('link[href*=kendo]');
        let languageCode = orion.getLocaleCode().substr(0, 2);

        if (assetElement !== null)
        {
            // Get the last 6 characters of the href attribute value (url)
            query += 'id=' + assetElement.getAttribute('href').substr(-6, 6);
        }

        query += '&shopProfileCode=' + orion.getShopProfileCode();

        // use dataLayer for customerId, which is an external dependency so we do some safety-checks
        if (typeof dataLayer !== 'undefined'
			&& typeof dataLayer[0] !== 'undefined'
			&& Object.prototype.hasOwnProperty.call(dataLayer[0], 'customerId')
			&& dataLayer[0]['customerId'] !== '')
        {
            query += '&customerId=' + dataLayer[0]['customerId'];
        }

        let promise = $.ajax({
            'url': '/api-ordered-search-facet-' + languageCode + query,
            'method': 'GET',
            'cache': true
        });

        return promise;
    }

    /**
	 * include the labels grouped by letters into the labels overview mega dropdown
	 * @param {object} labelList - the list of labels grouped by letter
	 */
    processLabelsOverview(labelList)
    {
        let labelOverviewList = document.querySelector(this.labelsOverviewSelector);
        let { catalogPath } = labelOverviewList.dataset;

        if (labelOverviewList === null)
        {
            return;
        }

        for (var labelLetterGroup in labelList)
        {
            let labelLetterItem = document.createElement('li');
            labelLetterItem.innerHTML = labelLetterGroup;
            labelLetterItem.classList.add('labels-overview-list__group-item');

            let labelLetterGroupList = document.createElement('ul');
            labelLetterGroupList.classList.add('labels-overview-list__label-list');

            labelList[labelLetterGroup].forEach(label =>
            {
                let labelItem = document.createElement('li');
                labelItem.classList.add('labels-overview-list__label-item');

                let labelLink = document.createElement('a');
                labelLink.setAttribute(
                    'href',
                    catalogPath + '?q=--0--24----labelNameFacet%3A%3A"' + encodeURIComponent(label) + '"'
                );
                labelLink.innerHTML = label;

                labelItem.appendChild(labelLink);

                labelLetterGroupList.appendChild(labelItem);
            });

            labelLetterItem.appendChild(labelLetterGroupList);
            labelOverviewList.appendChild(labelLetterItem);
        }
    }
}

let labelsOverview = new NavigationLabelsOverview();
labelsOverview.init();
